import React from "react";
import EntryForm from "../components/admin/EntryForm";

const AdminPage: React.FC = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Admin Dashboard</h1>
        <p className="text-gray-300">
          Add and manage savings entries in the DOWCE system.
        </p>
      </div>

      <EntryForm />
    </div>
  );
};

export default AdminPage;
